module.exports = __webpack_public_path__ + "img/nav_icon_reporting_light.38c72ea1.svg";